module.exports = __webpack_public_path__ + "static/img/导入人员模板.66e1e23.xls";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/导入人员模板.xls
// module id = OsMR
// module chunks = 1